import React, { useRef, useState, useEffect } from "react";

const Grid = ({ ticks, columns, showHorizontal, showVertical }) => (
  <>
    {showHorizontal && (
      <div className="absolute inset-0 flex flex-col justify-between">
        {ticks.map((_, i) => (
          <div
            key={`h-${i}`}
            className="border-t border-dashed border-gray-300 w-full"
          />
        ))}
      </div>
    )}

    {showVertical && (
      <div className="absolute inset-0 flex">
        {Array.from({ length: columns }).map((_, i) => (
          <div key={`v-${i}`} className="flex-1 flex justify-center">
            <div className="border-l border-dashed border-gray-300 h-full" />
          </div>
        ))}
      </div>
    )}
  </>
);

export default Grid;
